import { render, staticRenderFns } from "./QueryIndex.vue?vue&type=template&id=079956a5&scoped=true"
import script from "./QueryIndex.vue?vue&type=script&lang=js"
export * from "./QueryIndex.vue?vue&type=script&lang=js"
import style0 from "./QueryIndex.vue?vue&type=style&index=0&id=079956a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079956a5",
  null
  
)

export default component.exports